﻿import { Configuration, LogLevel } from "@azure/msal-browser";

const isLocalhost = window.location.hostname === "localhost";

export const msalConfig: Configuration = {
    auth: {
        clientId: "823d6a27-b21a-49de-b6b2-d3fb070fc018", // frontend app reg client id
        authority: "https://login.microsoftonline.com/7efb1103-b463-40ed-8ca0-6a6b5c339ab7", // tenant id
        // redirect uri needs to be registered in 'SPA Redirect URIs' in Entra > App Registration > (portal app) > Authentication 
        redirectUri: isLocalhost
            ? "https://localhost:44395/"
            : "https://" + window.location.hostname,
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            logLevel: LogLevel.Info,
            loggerCallback: (level, message) => {
                // while debugging:
                //console.log(`[MSAL] ${message}`);
            },
        },
    },

};

export const loginRequest = {
    // Backend client id can be found in Entra > App Registrations > Expose an API
    scopes: ["api://89989ad8-d600-409a-be9a-8689d88b92e4/access_as_user"]
};